import { COUPON_HISTORY_MESSAGES } from '@/utils/constants';
import { toastHistoryError } from '@/view/components/history/history-error';

// Xuất Excel dùng responseType 'blob' → lỗi cũng là blob, đọc lại JSON để lấy message
const readBlobMessage = async (data) => {
  try {
    return JSON.parse(await data.text()).message || null;
  } catch (error) {
    return null;
  }
};

/**
 * Toast lỗi như các màn lịch sử khác (toastHistoryError): 403 → không có quyền; 400 → câu API trả
 * (giới hạn 90 ngày, quá 50.000 dòng); còn lại → không tải được.
 */
export const showHistoryError = async (error) => {
  const response = error && error.response;
  const data = response && response.data;
  let readable = error;
  if (data && typeof data.text === 'function') {
    const message = await readBlobMessage(data);
    if (message) {
      readable = { response: { status: response.status, data: { message } } };
    }
  }
  toastHistoryError(
    readable,
    COUPON_HISTORY_MESSAGES.FORBIDDEN,
    COUPON_HISTORY_MESSAGES.LOAD_FAILED,
  );
};
